import type { BoardAgeGroup } from "./types";

/**
 * 年齢グループの表示順（default 掲示板・Sakura 掲示板で共通）。
 * `satisfies` で {@link BoardAgeGroup} と同期させ、型とのドリフトを防ぐ。
 * route の `z.enum` でも使うため `as const`（readonly タプル）で定義する。
 */
export const BOARD_AGE_GROUPS = [
  "under20",
  "twenties",
  "thirties",
  "forties",
  "fiftyPlus",
] as const satisfies readonly BoardAgeGroup[];

/**
 * 年齢（数値）が年齢グループに該当するか。
 * default 掲示板（単一選択）・Sakura 掲示板（複数選択）のクライアントサイド絞り込みで共通利用する。
 */
export const matchesAgeGroup = (age: number, group: BoardAgeGroup): boolean => {
  switch (group) {
    case "under20":
      return age < 20;
    case "twenties":
      return age >= 20 && age < 30;
    case "thirties":
      return age >= 30 && age < 40;
    case "forties":
      return age >= 40 && age < 50;
    case "fiftyPlus":
      return age >= 50;
  }
};
